export default "__VITE_ASSET__DI5UhGm5__"